<template>
  <v-container fluid>
    <v-row wrap align-center >
      <v-col cols=12>
        <div class="text-center">
          <h1 class="headline font-weight-medium">
            {{ $vuetify.lang.t(`$vuetify.landing.functionality.title`) }}
          </h1>
        </div>
        <v-divider class="my-3"></v-divider>
      </v-col>
    </v-row>

    <v-row wrap align="center" align-content="center" justify="center">

      <v-col id="functionalityViewer" cols="12" lg="6" align-self="center" justify-self="center">
        <v-container fluid class="text-center">
          <v-scroll-y-transition leave-absolute hide-on-leave>
            <template v-if="type === 'map'">
              <v-card :key="'functionality'" flat class="mx-auto" max-width="650" elevation="10">
                <v-img :transition="false" contain max-width="650" class="mx-auto"
                       :src="require('@/assets/landing/functionality.jpeg')"></v-img>
              </v-card>
<!--              <map-carousel :key="'carousel'"></map-carousel>-->
            </template>
            <template v-else-if="type === 'phone'">
              <v-card :key="'phone'" flat class="mx-auto" max-width="300" elevation="10">
                <v-img :transition="false" contain max-width="300" class="mx-auto"
                       :src="require('@/assets/landing/phone/phoneView_min.png')"></v-img>
              </v-card>
            </template>
            <template v-else-if="type === 'stats'">
              <stats-carousel :key="'stats'"></stats-carousel>
            </template>
            <template v-else-if="type === 'personification'">
              <v-card :key="'personification'" class="mx-auto" max-width="650" elevation="10">
                <v-img :transition="false" contain max-width="650" class="mx-auto"
                       :src="require('@/assets/landing/personification/ml.png')"></v-img>
              </v-card>
            </template>
          </v-scroll-y-transition>
        </v-container>
      </v-col>

      <v-col cols="12" lg="6" align-self="center" justify-self="center">
        <v-container fluid>
          <v-row justify="center" class="fill-height">
            <v-col class="d-flex child-flex" cols='12' md="5" sm="5">
              <functionality-card type="phone" @card-clicked="changeViewer"></functionality-card>
            </v-col>
            <v-col class="d-flex child-flex" cols='12' md="5" sm="5">
              <functionality-card type="map" @card-clicked="changeViewer"></functionality-card>
            </v-col>
            <v-col class="d-flex child-flex" cols='12' md="5" sm="5">
              <functionality-card type="stats" @card-clicked="changeViewer"></functionality-card>
            </v-col>
            <v-col class="d-flex child-flex" cols='12' md="5" sm="5">
              <functionality-card type="personification" @card-clicked="changeViewer"></functionality-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import FunctionalityCard from './functionality/functionalityCard'
import StatsCarousel from './functionality/statsCarousel'
import MapCarousel from './functionality/mapCarousel'
import metaMixin from '../../mixins/metaMixin'

export default {
  name: 'functionalitySlide',
  components: { MapCarousel, StatsCarousel, FunctionalityCard },
  mixins: [metaMixin],
  data: () => ({
    type: 'phone'
  }),
  methods: {
    changeViewer (type) {
      this.type = type

      if (['xs', 'sm'].includes(this.$vuetify.breakpoint.name)) {
        this.$vuetify.goTo(`#functionalityViewer`, {
          duration: 500,
          offset: 0,
          easing: 'easeInOutCubic'
        })
      }
    }
  },

  metaInfo: {
    title: 'Drive Safely | Features',
    meta: [
      { name: 'description', content: 'Drive Safely description with examples' },
      { property: 'og:title', content: 'Drive Safely features' },
      { property: 'og:site_name', content: 'Drive Safely' },
      { property: 'og:description', content: 'Drive Safely description with examples' },
      { property: 'og:url', content: 'https://mobiledrivesafely.com/functionality' }
    ]
  }
}
</script>

<style scoped>
  .func-slide-height {
    /*height: 100vh;*/
  }

  .background_color {
    background: linear-gradient(150deg, #ffe7e0 40%, #f2ddfd 60%);
    background-size: cover;
  }
</style>
